export { default as SmallChip } from './SmallChip';
export type { Props } from './SmallChip';
